import { ThemeEvents } from '@theme/events';

class ProductSku extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;

    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateSku);
    closestSection.addEventListener('sku:update', this.updateSku);

    const productForm = closestSection.querySelector(
      `product-form-component[data-product-id="${this.dataset.productId}"]`
    );
    const skuInput = productForm?.querySelector('input[name="sku"]');
    this.setSku(skuInput instanceof HTMLInputElement ? skuInput.value : '');
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;

    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateSku);
    closestSection.removeEventListener('sku:update', this.updateSku);
  }

  updateSku = (event) => {
    const isVariantUpdate = event.type === ThemeEvents.variantUpdate;
    const productId = isVariantUpdate ? event.detail.data.productId : event.detail.productId;

    if (productId !== this.dataset.productId) return;

    const sku = isVariantUpdate ? event.detail.resource?.sku : event.detail.sku;
    this.setSku(sku);
  };

  setSku(sku) {
    const skuText = this.querySelector('[ref="skuText"]');

    if (!skuText) return;

    const prefix = this.dataset.skuPrefix || '';
    skuText.textContent = sku ? `${prefix}${sku}` : prefix.trim();
    this.toggleAttribute('hidden', !sku && this.dataset.hideWhenBlank === 'true');
  }
}

if (!customElements.get('product-sku')) {
  customElements.define('product-sku', ProductSku);
}
